import {
  ConfirmModalProps,
  DeleteConfirmModal,
  GetModalProps
} from "@/molecules/ConfirmModal"

import styles from "./FooterConfigurationTemplate.module.scss"

export const DeleteConfirmModalConfiguration = (
  props: GetModalProps & ConfirmModalProps
) => {
  const { title, content, ...rest } = props
  const { t } = rest
  const keyPrefix = "components.configuration.modals.deleteConfirm"

  return DeleteConfirmModal({
    content,
    title: <span className={styles.title}>{title}</span>,
    messages: {
      success: t(`${keyPrefix}.success`),
      error: t(`${keyPrefix}.error`)
    },
    okText: t(`${keyPrefix}.okText`),
    ...rest
  })
}
